(function () {
  const config = window.HPGOpenAIAdsConfig;
  if (!config || typeof window.oaiq !== 'function') return;

  let consentAllowed = false;
  let productViewSent = false;

  function debugLog(message, detail) {
    if (!config.debug) return;
    console.info(`[OpenAI Ads] ${message}`, detail || '');
  }

  function measure(eventName, eventData, options) {
    if (!consentAllowed) {
      debugLog(`Blocked ${eventName}: consent not allowed`);
      return false;
    }

    if (options) {
      window.oaiq('measure', eventName, eventData, options);
    } else {
      window.oaiq('measure', eventName, eventData);
    }

    debugLog(`Measured ${eventName}`, eventData);
    return true;
  }

  function sendProductView() {
    if (productViewSent || !config.productView) return;

    const product = config.productView;
    productViewSent = measure('contents_viewed', {
      type: 'contents',
      amount: product.amount,
      currency: config.currency,
      contents: [
        {
          id: product.id,
          name: product.name,
          content_type: 'product',
          quantity: 1,
          amount: product.amount,
          currency: config.currency,
        },
      ],
    });
  }

  function syncConsent() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    const allowed = Boolean(privacy && privacy.marketingAllowed() && privacy.saleOfDataAllowed());

    consentAllowed = allowed;
    window.oaiq('consent', allowed);
    debugLog(`Consent ${allowed ? 'allowed' : 'blocked'}`);

    if (allowed) sendProductView();
  }

  function cartLines(response) {
    if (!response) return [];
    return Array.isArray(response.items) ? response.items : [response];
  }

  function lineAmount(line) {
    const amount = line.final_price ?? line.discounted_price ?? line.price;
    return Number.isInteger(amount) ? amount : Number.parseInt(amount, 10);
  }

  function trackCartAddResponse(response) {
    const contents = cartLines(response)
      .map((line) => {
        const amount = lineAmount(line);
        const quantity = Number.parseInt(line.quantity, 10) || 1;
        const id = line.variant_id || line.id;

        if (!id || !Number.isInteger(amount)) return null;

        return {
          id: String(id),
          name: line.product_title || line.title || 'Product',
          content_type: 'product',
          quantity,
          amount,
          currency: config.currency,
        };
      })
      .filter(Boolean);

    if (!contents.length) {
      debugLog('Skipped items_added: cart response has no measurable lines', response);
      return false;
    }

    const amount = contents.reduce((total, item) => total + item.amount * item.quantity, 0);
    return measure('items_added', {
      type: 'contents',
      amount,
      currency: config.currency,
      contents,
    });
  }

  window.HPGOpenAIAds = {
    measure,
    syncConsent,
    trackCartAddResponse,
  };

  document.addEventListener('visitorConsentCollected', syncConsent);

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    debugLog('Consent API loader unavailable; measurement remains blocked');
    return;
  }

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error) {
        debugLog('Consent API failed to load', error);
        return;
      }

      syncConsent();
    }
  );
})();
